import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import { TProductPriceHistoryForm } from "../../../features/productPriceHistories";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from "../../../components/common/Inputs/CustomDatePicket";

type ProductPriceHistoryFormProps = {
  formik: FormikProps<TProductPriceHistoryForm>;
};

export const ProductPriceHistoryForm = (
  props: ProductPriceHistoryFormProps,
) => {
  const { formik } = props;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CustomInput
        label="Precio"
        type="number"
        error={
          formik.touched.price &&
          formik.errors.price &&
          Array.isArray(formik.errors.price)
            ? formik.errors.price.join(", ")
            : formik.errors.price
        }
        {...formik.getFieldProps("price")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Costo"
        type="number"
        error={
          formik.touched.cost &&
          formik.errors.cost &&
          Array.isArray(formik.errors.cost)
            ? formik.errors.cost.join(", ")
            : formik.errors.cost
        }
        {...formik.getFieldProps("cost")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomDatePicker
        label="Fecha de inicio de vigencia"
        value={formik.values.effectiveFrom}
        handleChange={(date) => formik.setFieldValue("effectiveFrom", date)}
        error={
          formik.touched.effectiveFrom &&
          formik.errors.effectiveFrom &&
          typeof formik.errors.effectiveFrom === "string"
            ? formik.errors.effectiveFrom
            : undefined
        }
      />

      <CustomDatePicker
        label="Fecha de fin de vigencia"
        value={formik.values.effectiveTo}
        handleChange={(date) => formik.setFieldValue("effectiveTo", date)}
        error={
          formik.touched.effectiveTo &&
          formik.errors.effectiveTo &&
          typeof formik.errors.effectiveTo === "string"
            ? formik.errors.effectiveTo
            : undefined
        }
      />
    </div>
  );
};
